var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-mode"},[_c('h3',[_vm._v(_vm._s(_vm.mode))]),_c('span',[_vm._v("\n    id:\n    "),_c('h3',{staticClass:"cheque-id"},[_vm._v(_vm._s(_vm.chequeId))])])])}
var staticRenderFns = []

export { render, staticRenderFns }